import React, { PureComponent, Fragment } from "react";
import Modal from "react-bootstrap/Modal";
import CollapseComponent from "../MaterialUiCompnents/boostrapCollapse/index";

export default class AvisoPrivacidadModal extends PureComponent {
  constructor(props, context) {
    super(props, context);

    this.state = {
      show: false,
    };
  }

  render() {
    return (
      <Fragment>
        <Modal
          size="lg"
          show={this.props.modal}
          onHide={this.props.handleModal}
          style={{ zIndex: 10001 }}
          backdropClassName="aviso-privacidad-backdrop"
        >
          <Modal.Header closeButton>
            <Modal.Title>AVISO DE PRIVACIDAD INTEGRAL</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p style={{ textAlign: "center" }}>
              <strong>
                ¡Tú Privacidad es Nuestra Prioridad en McCormick México!
              </strong>
            </p>
            <p>
              <strong>MCCORMICK DE MÉXICO, S.A. DE C.V.</strong>, con domicilio
              en Calzada San Bartolo Naucalpan No. 360, Col. Argentina Poniente,
              Alcaldía Miguel Hidalgo, Ciudad de México, C.P. 11230, es la
              responsable del tratamiento de tus datos personales. Proteger tu
              información es fundamental para nosotros; por ello, queremos que
              sepas de forma clara el tratamiento que le damos a tus datos.
            </p>
            <ol>
              <li>
                <p>
                  <strong>¿Qué datos personales recabamos?</strong>
                </p>
                <p>
                  Para llevar a cabo las finalidades descritas en el presente
                  Aviso, recabamos los siguientes datos de nuestros clientes y
                  público en general a través de redes sociales, de forma
                  personal o vía telefónica:
                </p>
                <p>
                  <ul style={{ listStyleType: "disc" }}>
                    <li>
                      <strong>Datos de Identificación:</strong> Nombre completo
                      y edad.
                    </li>
                    <li>
                      <strong>Datos de Contacto:</strong> Correo electrónico,
                      teléfono y domicilio.
                    </li>
                    <li>
                      <strong>Documentación:</strong> Identificación oficial
                      (solo en casos específicos como entrega de premios o
                      ejercicio de derechos).
                    </li>
                  </ul>
                </p>
                <p>
                  <strong>Nota importante:</strong> No recabamos datos
                  personales sensibles (como salud, religión o postura
                  política). Recuerda que eres el responsable de la exactitud,
                  veracidad, autenticidad y vigencia de tus datos personales.
                </p>
              </li>
              <li>
                <p>
                  <strong>¿Para qué usamos tus datos?</strong>
                </p>
                <p>Tus datos tienen dos tipos de finalidades:</p>
                <ol type="A">
                  <li>
                    <p>
                      <strong>Finalidades Necesarias (Primarias):</strong>
                    </p>
                    <p>
                      <ul style={{ listStyleType: "disc" }}>
                        <li>Validar tu identidad y contactarte.</li>
                        <li>
                          Inscribirte en nuestras dinámicas, concursos o
                          eventos.
                        </li>
                        <li>
                          Entregarte incentivos u obsequios si resultas ganador.
                        </li>
                        <li>
                          Dar seguimiento a tus dudas, quejas o sugerencias.
                        </li>
                        <li>Cumplir con obligaciones legales.</li>
                        <li>
                          Compartirte recetas elaboradas con nuestros productos.
                        </li>
                      </ul>
                    </p>
                  </li>
                  <li>
                    <p>
                      <strong>Finalidades de Mejora (Secundarias):</strong>
                    </p>
                    <p>
                      <ul style={{ listStyleType: "disc" }}>
                        <li>
                          Conocer tus gustos para crear perfiles de consumo.
                        </li>
                        <li>Pedirte tu opinión sobre nuestros productos.</li>
                      </ul>
                    </p>
                  </li>
                </ol>
                <p>
                  <strong>
                    ¿No estás de acuerdo con las finalidades secundarias?
                  </strong>
                  , No hay problema. Tu negativa para las finalidades
                  secundarias no afectará. Puedes enviarnos un correo a:
                  <a href="mailto: protecciondedatos@herdez.com">
                    {" "}
                    protecciondedatos@herdez.com{" "}
                  </a>
                  solicitando tu derecho de Oposición respecto de las
                  finalidades secundarias.
                </p>
              </li>
              <li>
                <p>
                  <strong>¿Con quién compartimos tus datos?</strong>
                </p>
                <p>
                  Solo la compartimos con aliados estratégicos para que todo
                  funcione correctamente:
                </p>
                <p>
                  <ul style={{ listStyleType: "disc" }}>
                    <li>
                      <strong>Nuestra familia:</strong> Empresas del mismo grupo
                      corporativo para mejorar nuestra calidad.
                    </li>
                    <li>
                      <strong>Aliados:</strong> Proveedores de mensajería,
                      marketing o desarrolladores que nos ayudan a operar.
                    </li>
                    <li>
                      <strong>Autoridades:</strong> Solo si existe un
                      requerimiento legal fundamentado.
                    </li>
                  </ul>
                </p>
              </li>
              <li>
                <p>
                  <strong>
                    ¡Tú tienes el control! (Derechos ARCO) – Revocación de
                    consentimiento.
                  </strong>
                </p>
                <p>
                  Tú decides qué pasa con tus datos. En cualquier momento puedes
                  solicitar:
                </p>
                <p>
                  <ul style={{ listStyleType: "disc" }}>
                    <li>
                      <strong>A</strong>cceder a ellos.
                    </li>
                    <li>
                      <strong>R</strong>ectificarlos si son incorrectos.
                    </li>
                    <li>
                      <strong>C</strong>ancelar su uso.
                    </li>
                    <li>
                      <strong>O</strong>ponerte a ciertos tratamientos.
                    </li>
                  </ul>
                </p>
                <p>
                  También puedes <strong>revocar</strong> el consentimiento que
                  nos diste anteriormente.
                </p>
                <p>
                  <strong>¿Cómo hacerlo?</strong>
                </p>
                <p>
                  Envía un correo electrónico a{" "}
                  <a href="mailto: protecciondedatos@herdez.com">
                    {" "}
                    protecciondedatos@herdez.com{" "}
                  </a>{" "}
                  con lo siguiente:
                </p>
                <p>
                  <ol>
                    <li>Tu nombre completo y datos de contacto.</li>
                    <li>Copia de tu identificación oficial vigente.</li>
                    <li>
                      Si no lo haces tú mismo, el poder notarial o carta poder
                      de tu representante.
                    </li>
                    <li>
                      Una descripción clara y precisa de los datos personales
                      respecto de los que se busca ejercer alguno de los
                      derechos ARCO. En caso de Rectificación de datos
                      personales, ya sea que se encuentren incompletos,
                      desactualizados o sean inexactos, deberás indicar la
                      modificación exacta y anexar la documentación soporte.
                    </li>
                    <li>
                      Cualquier elemento que facilite la localización de los
                      datos personales.
                    </li>
                  </ol>
                </p>
                <p>
                  <strong>Nuestros tiempos de respuesta:</strong> Te
                  responderemos en un máximo de{" "}
                  <strong> 20 días hábiles. </strong> Si tu solicitud procede,
                  se hará efectiva en los
                  <strong> 15 días hábiles </strong>
                  siguientes a nuestra respuesta.
                </p>
              </li>
              <li>
                <p>
                  <strong>Tecnologías en nuestro sitio (Cookies).</strong>
                </p>
                <p>
                  Utilizamos &quot;cookies&quot; para que tu navegación sea más
                  fácil y personalizada. Estas herramientas nos permiten
                  recordar tus preferencias y analizar el uso de nuestro sitio.
                </p>
                <p>
                  Puedes deshabilitarlas: En cualquier momento puedes ajustar la
                  configuración de tu navegador (Chrome, Safari, etc.) para
                  limitar o bloquear el uso de cookies.
                </p>
              </li>
              <li>
                <p>
                  <strong>Cambios en este Aviso.</strong>
                </p>
                <p>
                  Este aviso puede actualizarse por nuevos requisitos legales o
                  necesidades del responsable. Siempre podrás consultar la
                  versión más reciente en:{" "}
                  <a href="https://www.mccormick.mx/">
                    https://www.mccormick.mx/
                  </a>
                  .
                </p>
              </li>
            </ol>
            <div style={{ width: "100%", textAlign: "end" }}>
              <p>Última actualización: Junio/2026.</p>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              className="btn mr-auto ml-auto btn-carousel"
              variant="primary"
              onClick={this.props.handleModal}
            >
              Cerrar
            </button>
          </Modal.Footer>
        </Modal>
      </Fragment>
    );
  }
}
